import 'reflect-metadata';
import { Injector } from "./injector.js";
/**
 * Options for the injectable instance
 */

/**
 * The default options for the injectable classes
 */
export const defaultInjectableOptions = {
  lifetime: 'transient'
};
/**
 * Decorator method for tagging a class as injectable
 * @param options The options object
 */

export const Injectable = options => {
  return ctor => {
    const meta = Reflect.getMetadata('design:paramtypes', ctor);
    const metaValue = {
      dependencies: meta && meta.map(param => {
        return param;
      }) || [],
      options: { ...defaultInjectableOptions,
        ...options
      }
    };
    Injector.meta.set(ctor, metaValue);
  };
};
//# sourceMappingURL=injectable.js.map